import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"

export default function LetterClosingRender({ renderPkg }:{ renderPkg?:any }){

  const parseProps = { clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata}

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "letter_closing").settings || {}
  const outerStyling = useRenderStyling("mm-section w-full pl-3", "styleObj")
  
  return(
    <div id="mm-letter-closing" {...outerStyling}>
      <p>Sincerely,<br/>
        <span>
          { parseContent({content: "[[merchant.DBA]]", ...parseProps}).result } 
          Finance Department
        </span>
      </p>
    </div>
  )
}